import merge from "lodash/merge";
import UserNotification from "util/UserNotification";
import usePluginEntities from "hooks/usePluginEntities";
const executeSafely = (fn, errorMessage, fallbackResult) => {
  try {
    return fn();
  } catch (e) {
    console.error(`${errorMessage}: ${e}`);
    UserNotification.error(`${errorMessage}: ${e}`);
  }
  return fallbackResult;
};
const initialValues = (currentQuery, initialValuesHandler) => {
  const _initialValues = initialValuesHandler.map(
    (useInitialValues) => executeSafely(
      () => useInitialValues(currentQuery),
      "An error occurred when collecting initial search bar form values from a plugin",
      {}
    )
  );
  return merge({}, ..._initialValues);
};
export const useInitialSearchValues = (currentQuery) => {
  var _a;
  const pluggableSearchBarControls = (_a = usePluginEntities("views.components.searchBar")) != null ? _a : [];
  const initialValuesHandler = pluggableSearchBarControls == null ? void 0 : pluggableSearchBarControls.map((pluginFn) => {
    var _a2;
    return (_a2 = pluginFn()) == null ? void 0 : _a2.useInitialSearchValues;
  }).filter((useInitialValues) => !!useInitialValues);
  return initialValues(currentQuery, initialValuesHandler);
};
export const useInitialDashboardWidgetValues = (currentWidget) => {
  var _a;
  const pluggableSearchBarControls = (_a = usePluginEntities("views.components.searchBar")) != null ? _a : [];
  const initialValuesHandler = pluggableSearchBarControls == null ? void 0 : pluggableSearchBarControls.map((pluginFn) => {
    var _a2;
    return (_a2 = pluginFn()) == null ? void 0 : _a2.useInitialDashboardWidgetValues;
  }).filter((useInitialValues) => !!useInitialValues);
  return initialValues(currentWidget, initialValuesHandler);
};
const executeSubmitHandler = async (dispatch, values, submitHandlers, currentEntity) => {
  let updatedEntity = currentEntity;
  for (const submitHandler of submitHandlers) {
    const entityWithPluginData = await submitHandler(values, dispatch, updatedEntity).catch((e) => {
      const errorMessage = `An error occurred when executing a submit handler from a plugin: ${e}`;
      console.error(errorMessage);
      UserNotification.error(errorMessage);
      return updatedEntity;
    });
    if (entityWithPluginData) {
      updatedEntity = entityWithPluginData;
    }
  }
  return updatedEntity;
};
export const executeSearchSubmitHandler = (dispatch, values, pluggableSearchBarControls, currentQuery) => {
  const pluginSubmitHandlers = pluggableSearchBarControls == null ? void 0 : pluggableSearchBarControls.map((pluginFn) => {
    var _a;
    return (_a = pluginFn()) == null ? void 0 : _a.onSearchSubmit;
  }).filter((pluginData) => !!pluginData);
  return executeSubmitHandler(dispatch, values, pluginSubmitHandlers, currentQuery);
};
export const executeDashboardWidgetSubmitHandler = (dispatch, values, pluggableSearchBarControls, currentWidget) => {
  const pluginSubmitHandlers = pluggableSearchBarControls == null ? void 0 : pluggableSearchBarControls.map((pluginFn) => {
    var _a;
    return (_a = pluginFn()) == null ? void 0 : _a.onDashboardWidgetSubmit;
  }).filter((pluginData) => !!pluginData);
  return executeSubmitHandler(dispatch, values, pluginSubmitHandlers, currentWidget);
};
export const pluggableValidationPayload = (values, context, pluggableSearchBarControls = []) => {
  const validationPayloadHandler = pluggableSearchBarControls.map((pluginFn) => {
    var _a;
    return (_a = pluginFn()) == null ? void 0 : _a.validationPayload;
  }).filter((validationPayloadFn) => !!validationPayloadFn);
  const validationPayload = validationPayloadHandler.map(
    (validationPayloadFn) => executeSafely(
      () => validationPayloadFn(values, context),
      "An error occurred when preparing search bar validation for a plugin",
      {}
    )
  );
  return merge({}, ...validationPayload);
};
export const validatePluggableValues = (values, context, pluggableSearchBarControls = []) => {
  const validationHandler = pluggableSearchBarControls.map((pluginFn) => {
    var _a;
    return (_a = pluginFn()) == null ? void 0 : _a.onValidate;
  }).filter((onValidate) => !!onValidate);
  const errors = validationHandler.map(
    (onValidate) => executeSafely(
      () => onValidate(values, context),
      "An error occurred when validating search bar values from a plugin",
      {}
    )
  );
  return merge({}, ...errors);
};
